// extracted by mini-css-extract-plugin
export default {"avatarTxtCont":"styles_avatarTxtCont__gSodw","weight500":"styles_weight500__NBIyY","dropDownIcon":"styles_dropDownIcon__6MYQe"};